import { render, staticRenderFns } from "./OsAntesDiscEditor.vue?vue&type=template&id=a40e87aa&scoped=true"
import script from "./OsAntesDiscEditor.vue?vue&type=script&lang=ts"
export * from "./OsAntesDiscEditor.vue?vue&type=script&lang=ts"
import style0 from "./OsAntesDiscEditor.vue?vue&type=style&index=0&id=a40e87aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40e87aa",
  null
  
)

export default component.exports